const cashIn = {
    id: `cashin-${Math.random()}`,
    title: 'Cash In',
    type: 'item',
    url: `/transaction/cashin`,
    // icon: icons.IconReport,
    breadcrumbs: false,
    // children: transChild,
    role: process.env.REACT_APP_RL_TRANSCASHIN
};

export default cashIn;